import { searchParamKeys } from '../../constants/filter-constants'

export const stripNonSearchQueryParametersFromUrl = (url: string) => {
  const [path, originalQueryString] = url.split('?')

  const originalQueryParams = new URLSearchParams(originalQueryString)
  const newQueryParams = new URLSearchParams()

  // only copy the params we care about into the new URLSearchParams
  originalQueryParams.forEach((value, key) => {
    if ((searchParamKeys as ReadonlyArray<string>).includes(key)) {
      newQueryParams.set(key, value)
    }
  })
  // sort in place by key name to provide a stable order, and hopefully further increase cache hits
  newQueryParams.sort()
  const newQueryString = `${newQueryParams}`
  if (newQueryString) {
    return `${path}?${newQueryParams}`
  }
  return path
}
